<section class="navigation">
  <pwj-section-tabs
    [tabs]="tabsData()"
    translateKey="products."
    [isBorderedMode]="true"
    [isNavigationMode]="true"></pwj-section-tabs>
</section>
